module.exports = __webpack_public_path__ + "static/media/marque-miniparcours.ec3f7626.glb";